import { PoposedToTheSubCommittee4ApproveContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4ApproveContainer";
export function PoposedToTheSubCommittee4ApprovePage() {

    return (
        <PoposedToTheSubCommittee4ApproveContainer />
    )
}




